import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 782A053A-D6FF-4B8E-B3A2-4ADCB6A7BA9A
 * name fridge-variant-alert-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fridge-variant-alert-outline.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 */
export const FridgeVariantAlertOutlineIcon = createSvgIcon(<><path d="M15 2H5C3.9 2 3 2.9 3 4V19C3 20.11 3.9 21 5 21V22H7V21H13V22H15V21C16.11 21 17 20.11 17 19V4C17 2.9 16.11 2 15 2M9 19H5V14H8V10H5V4H9V19M15 19H11V4H15V19M19 15H21V17H19V15M21 7V13H19V7H21Z" /></>, 'FridgeVariantAlertOutlineIcon');
export default FridgeVariantAlertOutlineIcon